import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


const __default__ = {
  name: 'InputEditor'
}

import { ref, toRefs, onMounted } from 'vue'
import { NInput, NTooltip } from 'naive-ui'
import { onClickOutside, onKeyStroke } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  text: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  maxlength: {
    type: Number,
    default: 15
  }
},
  emits: ["update"],
  setup(__props, { emit }: { emit: ({
  (e: 'update', text: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props



const input = ref<typeof NInput | null>(null)
const { text } = toRefs(props)
const inputValue = ref(text.value)
const target = ref(null)
const isShowTooltip = ref(false)
const update = () => {
  emit('update', inputValue.value)
}
const handleValueChange = () => {
  if (inputValue.value.length === props.maxlength) {
    isShowTooltip.value = true
  } else {
    isShowTooltip.value = false
  }
}
// 滚动光标位置
const handleScrollPos = e => {
  input.value?.scrollTo({
    behavior: 'smooth',
    left: e.srcElement.selectionStart > 9 ? 100 : e.srcElement.selectionStart
  })
  input.value?.focus()
}
onMounted(() => {
  input.value?.select()
})
// 处理点击确认事件
onClickOutside(target, update)
onKeyStroke(['Enter'], update)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "editor-wrap",
    ref_key: "target",
    ref: target
  }, [
    _createVNode(_unref(NTooltip), {
      show: isShowTooltip.value,
      trigger: "manual",
      placement: "bottom-start",
      "show-arrow": false,
      class: "custom-tooltip-style"
    }, {
      trigger: _withCtx(() => [
        _createVNode(_unref(NInput), {
          ref_key: "input",
          ref: input,
          maxlength: props.maxlength,
          autofocus: "",
          placeholder: props.placeholder,
          class: "editor__input",
          value: inputValue.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
          onKeyup: handleValueChange,
          onClick: handleScrollPos
        }, null, 8, ["maxlength", "placeholder", "value"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", null, "最多支持输入" + _toDisplayString(__props.maxlength) + "个汉字", 1)
      ]),
      _: 1
    }, 8, ["show"])
  ], 512))
}
}

})